<template>
  <Card :title="$t('global.general-options')">
    <LoadingState v-if="isLoading()" :size="50" />
    <ErrorState v-else-if="isErrored()" />
    <div v-else-if="options">
      <CardActionContent :buttons="getButtons()">
        <template #description>
          <LoadingState v-if="isUpdating()" :size="50" />
          <CardListContent v-else :list="getList()" />
        </template>
      </CardActionContent>
    </div>
  </Card>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import SiteUpdateCronOptions from "@/components/smart/modals/SiteUpdateCronOptions";
import store from "@/store";

export default {
  name: "GeneralOptions",
  components: {
    Card,
    CardActionContent,
    CardListContent,
    ErrorState,
    LoadingState,
  },
  props: {
    resourceName: String,
    site: Object,
  },
  setup(props, { root }) {
    const options = computed(() => store.getters["siteCron/getOptions"]);
    const status = computed(() => store.getters["siteCron/getOptionsStatus"]);

    const isErrored = () => status.value.isErrored;
    const isLoading = () => status.value.isLoading;
    const isUpdating = () => status.value.isUpdating;

    const getButtons = () => {
      if (!(status.value.isLoaded || status.value.isUpdating)) return null;
      return [
        new NavLink(
          root.$t("global.update"),
          null,
          openUpdateForm,
          false,
          "primary",
          null,
          isUpdating() || props.disabled
        ),
      ];
    };

    const getList = () => [
      {
        label: root.$t("global.path"),
        content: options.value.path,
        canCopy: true,
      },
      {
        label: root.$t("global.mail-to"),
        content: options.value.mailTo,
        canCopy: !!options.value.mailTo,
      },
    ];

    const openUpdateForm = () =>
      store.dispatch("modals/open", {
        template: SiteUpdateCronOptions,
        data: { resourceName: props.resourceName, site: props.site, options: options.value },
      });

    onMounted(() => {
      store.dispatch("siteCron/getOptions", props.site.id);
    });

    return {
      getButtons,
      getList,
      isErrored,
      isLoading,
      isUpdating,
      options,
      status,
    };
  },
};
</script>
